import * as React from 'react';

const Loading = (): JSX.Element => <h1>Loading...</h1>;

export default Loading;
